import React, { createContext, ReactNode } from 'react';

export type ConfigProviderProps = {
  contentfulImageQuality?: string;
};

export const ConfigContext = createContext<ConfigProviderProps | Record<string, any>>({});

export const useConfigContext = () => {
  const value = React.useContext(ConfigContext);
  if (!Object.keys(value).length) {
    console.error('useConfigContext must be used within a ConfigProvider');
  }
  return value;
};

export const ConfigProvider = ({
  contentfulImageQuality = '100',
  children,
}: ConfigProviderProps & { children: ReactNode }) => (
  <ConfigContext.Provider value={{ contentfulImageQuality }}>{children}</ConfigContext.Provider>
);
